//  ----------      START   IMPORT  BLOCK       ----------
import { useRef } from "react";
//  Widgets
import { Modal, Button } from "react-bootstrap";
//  Utils
import QRWithLogo from "../../../../Utils/qrWithLogo"
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
//  Context
import { useLanguage } from "../../../../API/Context/LanguageContext";
//  Config
import {VocabButtons as btn_vocab} from "../../../../ConfigFiles/multilingual/VocabButtons";
import VocabQRWithLogo from "../../../../ConfigFiles/multilingual/VocabQRWithLogo";
//  ----------      END   IMPORT  BLOCK       ----------

const QRModal = ({ show, handleClose, destinationLink }) => {
  const { lan } = useLanguage()
  const qrRef = useRef();

  const downloadPDF = async () => {
    const element = qrRef.current;
    if (!element) return;

    const canvas = await html2canvas(element);
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF();
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("qr-code.pdf");
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{VocabQRWithLogo.qr_code[lan]}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex flex-column align-items-center">
        <div ref={qrRef}>
          <QRWithLogo size={250} data={destinationLink} lan={lan} message={VocabQRWithLogo.scan_me[lan]} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {btn_vocab.close[lan]}
        </Button>
        <Button variant="primary" onClick={downloadPDF}>
          {btn_vocab.download[lan]}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default QRModal;
